module.exports = __webpack_public_path__ + "img/advanced1.b7977839.png";